<!-- SVGを読み込んで表示する -->
<script lang="ts" setup>
import { shallowRef, watch } from 'vue';

// props
const props = withDefaults(
  defineProps<{
    name: string;
    toolTipValue?: string;
    disabled?: boolean;
  }>(),
  {
    toolTipValue: '',
    disabled: false,
  }
);

// emits
const emits = defineEmits<{
  (e: 'click'): void;
}>();

// svgファイルをコンテキストとして読み込む
const svgModules = require.context('@/assets/svg', false, /\.svg$/);

// 現在表示するSVGのコンポーネント
const svg = shallowRef<Promise<any> | null>(null);

// 初期化 & 監視
const loadSvg = () => {
  const filePath = `./${props.name}.svg`;
  if (svgModules.keys().includes(filePath)) {
    svg.value = svgModules(filePath).default;
  } else {
    console.warn(`SVGファイルが見つかりません: ${filePath}`);
    svg.value = null;
  }
};

// watch
watch(() => props.name, loadSvg, { immediate: true });

/**
 * tooltip表示の有無を決める関数(とりあえず今は1文字以上あったら表示するくらいに)
 * @returns tooltip表示の有無
 */
const isDisplayTooltip = (): boolean => {
  return !!props.toolTipValue;
};
</script>

<template>
  <div v-if="disabled" class="disabled">
    <component :is="svg" />
  </div>
  <div v-else @click="emits('click')">
    <component :is="svg" v-if="isDisplayTooltip()" v-tooltip.bottom="props.toolTipValue" />
    <component :is="svg" v-else />
  </div>
</template>

<style scoped lang="scss">
.disabled {
  opacity: $transparency50;
}
</style>
